import React from "react"
import styled from "styled-components"
import { translate } from "react-i18next"

const Icon = styled.i`
  color: #e50000;
  font-size: 24px;
`

const WidgetExportDownloadErrorNotification = ({ t }) => {
  return (
    <div className="text-center">
      <div style={{ margin: "5px 0" }}>
        <Icon className="fa fa-exclamation-circle" aria-hidden="true" />
      </div>
      {t("Widgets.Shared.ExportFailed")}
    </div>
  )
}

export default translate()(WidgetExportDownloadErrorNotification)



// WEBPACK FOOTER //
// ./src/components/layout/widget/WidgetExportDownloadErrorNotification.jsx